import React from 'react';
import { FilterTypes } from '@digitalexperience/dealer-website-core';
import GenericList from '../../../../../components/common/GenericList';
import { includes } from 'lodash';

const InteriorUpholsteryFilter = ({ filterData, filterValues, filterAdd, filterDelete }) => {
  const handleChange = (data) => {
    if (includes(filterValues, data.value)) {
      filterDelete(FilterTypes.interiorUpholstery, data.value);
    } else {
      filterAdd(FilterTypes.interiorUpholstery, data.value);
    }
  };
  return (
    <React.Fragment>
      <div className='builder-font-semibold builder-mb-2 builder-mt-5'>Interior upholstery</div>
      <GenericList items={filterData} values={filterValues} handleFilterChanged={handleChange} />
    </React.Fragment>
  );
};

export default InteriorUpholsteryFilter;
